
const resetTCQ = (configObj: any) => {
    const { _tcq } = window as any;
    // eslint-disable-next-line @typescript-eslint/no-namespace
    if (typeof _tcq == 'undefined') {
        // this.resetTCQ(configObj)
    } else {
        // _tcq = _tcq || [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in,
        for (const key in configObj) {
            let hasKey = false;
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const index in _tcq) {
                const item = _tcq[index];
                if (item[0] == key) {
                    hasKey = true;
                    _tcq[index][1] = configObj[key];
                }
            }
            if (!hasKey) {
                _tcq.push([key, configObj[key]]);
            }
        }
    }
};

/**
 * 页面埋点
 * Category（类别）, action（操作）, opt_label（标签）, opt_value（值）
 */
// eslint-disable-next-line camelcase,
const pageTrackEvent = (action: any, opt_label: any, opt_value = '' as any, category = '' as any) => {
    const { _tcTraObj } = window as any;
    // eslint-disable-next-line camelcase, no-self-assign, no-param-reassign
    opt_value = opt_value;
    // eslint-disable-next-line no-self-assign, no-param-reassign
    category = category;
    try {
        _tcTraObj._tcTrackEvent(category, action, opt_label, opt_value);
    } catch (e) {}
};

/**
 * 统计页面的pv，uv
 */
const pageTrack = (pagename: any, orgpagename: any) => {
    const { _tcTraObj } = window as any;;
    if (typeof _tcTraObj == 'undefined') {
        // eslint-disable-next-line no-implied-eval
        const t = setTimeout(`_tcTraObj._tcTrackPage('${pagename}','${orgpagename}');`, 200);
    } else {
        _tcTraObj._tcTrackPage(pagename, orgpagename);
    }
};


export {
    resetTCQ,
    pageTrackEvent,
    pageTrack,
};